/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid, IconButton, LinearProgress, TextField,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import { useDispatch, useSelector } from 'react-redux';
import {
  AddCircleOutlineRounded,
  CloseRounded,
  NotificationsOutlined,
  RemoveCircleOutlineRounded,
} from '@mui/icons-material';
import moment from 'moment';
import Elements from '../../../Elements';
// import Images from '../../../../Configs/images';
import {
  createNewStorages,
  deleteStorage,
  getDigitalBox,
  getDigitalBoxDetails,
  moveStorageSiteLoc,
  notifyUserBrokenItem,
} from '../../../../Redux/Models/box';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';
import { onlyNumbers } from '../../../../Utils/helpers';
import AlertContext from '../../../../Context/AlertContext';
import { alphabets } from '../../../../Configs/alphabets';
import ConfirmationContext from '../../../../Context/ConfirmationContext';
import { BoxToValidate } from '../RequestIn2/Component';
import dummy from '../../../../Configs/dummy';

export default function Storages({
  classes,
  data,
  selected,
  isLoading,
  isLoadingDetails,
  deletedStorage,
  error,
  message,
  notifiedUser,
  storageMoved,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { openConfirmation, closeConfirmation } = useContext(ConfirmationContext);
  const { openAlert } = useContext(AlertContext);

  const [selectedBox, setSelectedBox] = useState('');
  const [openAddNew, setOpenAddNew] = useState(false);
  const [openAisle, setOpenAisle] = useState(false);
  const [activeTab, setActiveTab] = useState(1);

  useEffect(() => {
    if (error) {
      openAlert({
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  const handleChangeTab = (e, newVal) => {
    setActiveTab(newVal);
  };

  const handleToggleAddNew = (newStorage) => {
    setOpenAddNew(!openAddNew);
    if (newStorage) {
      dispatch(getDigitalBox());
    }
  };

  useEffect(() => {
    dispatch(getDigitalBox());
  }, []);

  useEffect(() => {
    if (selectedBox) {
      dispatch(getDigitalBoxDetails(selectedBox));
    }
  }, [selectedBox]);

  useEffect(() => {
    if (selectedBox || deletedStorage) {
      if (deletedStorage) {
        dispatch(getDigitalBox());
        openAlert({
          title: 'Success',
          message: 'Storage has been deleted',
          severity: 'success',
        });
      }
    }
  }, [selectedBox, deletedStorage]);

  useEffect(() => {
    if (notifiedUser) {
      openAlert({
        title: 'Success',
        message: 'User has been notified',
        severity: 'success',
      });
    }
  }, [notifiedUser]);

  const handleDelete = (id) => {
    openConfirmation({
      title: 'Delete storage',
      desc: 'Are you sure want to delete this storage',
      confirmText: 'Delete',
      cancelText: 'Cancel',
      handleAgree: () => {
        dispatch(deleteStorage(id));
        closeConfirmation();
      },
      handleClose: () => {
        closeConfirmation();
      },
    });
  };

  const handleNotifyUser = (id) => {
    setSelectedBox('');
    openConfirmation({
      title: 'Notify user',
      desc: 'Notify user that their item(s) is broken and being replaced',
      confirmText: 'Yes',
      cancelText: 'Cancel',
      handleAgree: () => {
        dispatch(notifyUserBrokenItem(id));
        closeConfirmation();
      },
      handleClose: () => {
        closeConfirmation();
      },
    });
  };

  const [digitalBoxId, setDigitalBoxId] = useState('');
  const [boxId, setBoxId] = useState('');

  const chooseAisle = (item) => {
    setDigitalBoxId(item?.digital_box_id);
    setBoxId(item?.id);
    setSelectedBox('');
    setOpenAisle(true);
  };

  const handleDigitalBox = (val) => {
    if (val?.length) {
      const selectedAisleId = val[0]?.id;

      const body = {
        source_digital_box_id: digitalBoxId,
        target_digital_box_id: selectedAisleId,
        box_id: boxId,
      };

      dispatch(moveStorageSiteLoc(body));
    }
  };

  useEffect(() => {
    if (storageMoved) {
      openAlert({
        title: 'Success',
        message: 'Items has been moved to new storage location',
        severity: 'success',
      });
      setDigitalBoxId('');
      setBoxId('');
    }
  }, [storageMoved]);

  const renderBoxes = () => {
    if (data?.data?.length) {
      return (
        <Grid container spacing={2} sx={{ mt: 2 }}>
          {data.data.map((e, idx) => {
            const columnLength = e.row[0].column?.length;
            return (
              <Grid item sm="auto" key={idx} sx={{ mb: 2 }}>
                <Box border="1px solid #E5E5E5" borderRadius="10px" p={2} boxSizing="border-box">
                  <div className="center">
                    <div className="flex space-between align-items-center">
                      <Box className="weight-700" fontSize={24}>
                        Aisle
                        {' '}
                        {e.title}
                      </Box>
                      <Box>
                        <IconButton sx={{ pt: 0, pr: 0 }} onClick={() => handleDelete(e.rack_id)}>
                          <img src={Images.Trash} alt="trash" width="18" height="18" />
                        </IconButton>
                      </Box>
                    </div>
                  </div>
                  <Box className="flex align-items-center gap-8" fontSize={16}>
                    <div className="flex align-items-center">
                      <div className="weight-700">{e.used}</div>
                      <div className="s-14">not available</div>
                    </div>
                    <Box bgcolor="#2E3C40" height={4} width={4} className="circle" />
                    <div className="flex align-items-center">
                      <div className="weight-700">{e.available}</div>
                      <div className="s-14">available</div>
                    </div>
                    <Box bgcolor="#2E3C40" height={4} width={4} className="circle" />
                    <div className="flex align-items-center">
                      <div className="weight-700">{e.total}</div>
                      <div className="s-14">total</div>
                    </div>
                  </Box>
                  <Box display="flex" flexDirection="column" alignItems="center">
                    <table className="mt-3" cellSpacing={12}>
                      <thead>
                        <tr>
                          <td aria-label="empty-td" />
                          {new Array(columnLength).fill(null).map((col, id) => (
                            <td className="s-14 center weight-700 mute" key={id}>{id + 1}</td>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {e.row.map((ev, i) => (
                          <tr key={i}>
                            <td className="s-14 weight-700 mute">{alphabets[i]}</td>
                            {ev.column.map((col) => (
                              <td key={col.id}>
                                <div
                                  onClick={() => setSelectedBox(col.id)}
                                  className={`storage pointer ${col.status} ${selectedBox === col.id && 'selected'}`}
                                >
                                  {isLoadingDetails && selectedBox === col.id
                                    ? <CircularProgress color="inherit" size={36} /> : null}
                                </div>
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Box>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      );
    }

    return null;
  };

  return (
    <Elements.AdminPageBase navigate={navigate} title="Storages">
      <div className={classes.root}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box>
            <strong>Upgrade Storage</strong>
          </Box>
          <Box>
            <Button
              onClick={handleToggleAddNew}
              className="btn-contained"
              sx={{ px: 3, fontSize: 14 }}
              size="small"
              fullWidth
            >
              Add New Aisle
            </Button>
          </Box>
        </Box>
        <Box
          boxShadow="2px 3px 6px rgba(0, 0, 0, 0.04), 0px 2px 8px rgba(0, 0, 0, 0.02)"
          bgcolor="#FDFDFD"
          borderRadius="10px"
          border="1px solid #F5F6F8"
          py={3}
          px={5}
          mt={3}
        >
          <div className="flex space-between">
            <Box className="flex align-items-center gap-16" fontSize={24}>
              <div className="flex align-items-center">
                <div className="weight-700">{data.used}</div>
                <div className="s-16">not available</div>
              </div>
              <Box bgcolor="#2E3C40" height={4} width={4} className="circle" />
              <div className="flex align-items-center">
                <div className="weight-700">{data.available}</div>
                <div className="s-16">available</div>
              </div>
              <Box bgcolor="#2E3C40" height={4} width={4} className="circle" />
              <div className="flex align-items-center">
                <div className="weight-700">{data.total}</div>
                <div className="s-16">total</div>
              </div>
            </Box>

            <div className="flex align-self-center gap-16">
              <div className="flex align-items-center">
                <div className="storage not_available" />
                <div>
                  <div className="weight-700">Used storage</div>
                </div>
              </div>
              <div className="flex align-items-center">
                <div className="storage empty" />
                <div>
                  <div className="weight-700">Empty storage</div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-4">
            {isLoading && <LinearProgress color="inherit" className="mt-4" />}
            {renderBoxes()}
          </div>
        </Box>
        <GenerateNewStorages classes={classes} open={openAddNew} handleClose={handleToggleAddNew} />
        <Elements.ModalBase
          handleClose={() => setSelectedBox('')}
          open={Boolean((selected.item || selected.box) && selectedBox)}
          maxWidth="md"
          fullWidth
          smallBtn
          noAgree
          disabled
        >
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box fontSize={18} fontWeight="700">Storage Detail</Box>
            <IconButton sx={{ py: 0 }} onClick={() => setSelectedBox('')}>
              <CloseRounded />
            </IconButton>
          </Box>
          <Divider sx={{ my: 2 }} />
          <Grid container spacing={2}>
            {selected.box?.map((item, idx) => (
              <Grid item sm={6} key={idx}>
                <Box display="flex" gap={1.5} alignItems="flex-start">
                  <img width="80" height="80" className="rounded cover" src={item?.photo || dummy.img} alt={item?.name} />
                  <Box flex={1}>
                    <div className="weight-600">
                      {item?.name || `Box ${item?.digital_box_id}`}
                    </div>
                    <Box className="weight-500">
                      {item?.amount}
                      {' '}
                      Items
                    </Box>
                    <Box display="flex" alignItems="center" mt={0.5} gap={1.5} flexWrap="wrap">
                      <Box className="link underline" onClick={() => navigate(`${ROUTES.customers()}/detail/${item?.user_id}`)}>
                        {item?.user?.address?.name || '-'}
                      </Box>
                      <Box className="primary-green link weight-700 underline" onClick={() => navigate(`${ROUTES.requestIn()}/${item?.request_id}`)}>
                        {item?.request_id?.substring(0, 8)}
                        ...
                      </Box>
                      <Box>
                        {moment(item?.date_in).format('DD MMM YYYY, HH.mm')}
                      </Box>
                    </Box>
                    <Box display="flex" gap={1} mt={1}>
                      <Box className="jura link weight-700 underline" onClick={() => chooseAisle(item)}>Change</Box>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>

          <Grid container spacing={2} mt={4}>
            {selected.item?.map((item, idx) => (
              <Grid item key={idx} sm={6}>
                <Box display="flex" gap={1.5} alignItems="flex-start">
                  <img width="80" height="80" className="rounded cover" src={item?.photo || 'https://images.pexels.com/photos/2912108/pexels-photo-2912108.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500'} alt={selected?.box?.name} />
                  <Box flex={1}>
                    <div className="weight-600">{item?.name}</div>
                    <Box
                      display="flex"
                      fontWeight="400"
                      className="s-10"
                      color="#586479"
                      gap={0.5}
                      flexWrap="wrap"
                      lineHeight={1}
                      alignItems="center"
                      mt={0.5}
                    >
                      <div>{item?.category?.name || '-'}</div>
                      <div>
                        ・
                        {item?.condition?.name || '-'}
                      </div>
                      <div>
                        ・
                        {item?.volume || '0 mL'}
                      </div>
                    </Box>
                    <Box display="flex" alignItems="center" mt={0.5} gap={1.5} flexWrap="wrap">
                      <Box className="link underline" onClick={() => navigate(`${ROUTES.customers()}/detail/${item.user_id}`)}>
                        {item.user?.address?.name || '-'}
                      </Box>
                      <Box className="primary-green link weight-700 underline" onClick={() => navigate(`${ROUTES.requestIn()}/${item.request_id}`)}>
                        {item.request_id?.substring(0, 8)}
                        ...
                      </Box>
                      <Box>
                        {moment(item.date_in).format('DD MMM YYYY, HH.mm')}
                      </Box>
                    </Box>
                    <Box display="flex" gap={1} mt={1}>
                      <Box className="jura link weight-700 underline" onClick={() => chooseAisle(item)}>Change</Box>
                      <Box className="jura link weight-700 underline" onClick={() => handleNotifyUser(item.id)}>Replace</Box>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>

          <Divider sx={{ my: 2, pt: 2 }} />
        </Elements.ModalBase>

        <BoxToValidate
          neededStorage={1}
          classes={classes}
          updateDigitalBox={handleDigitalBox}
          chooseOnly
          open={openAisle}
          handleClose={() => setOpenAisle(false)}
        />
      </div>
    </Elements.AdminPageBase>
  );
}

function NoData({ title, desc }) {
  return (
    <div className="center box-info mt-3">
      <img src={Images.RunOut} alt="no data" />
      <h4 className="mt-3">{title}</h4>
      <div className="mt-3">{desc}</div>
    </div>
  );
}

function GenerateNewStorages({ classes, open, handleClose }) {
  const [rows, setRows] = useState(1);
  const [column, setColumn] = useState(1);
  const [name, setName] = useState('');
  const dispatch = useDispatch();
  const { newStorages, isLoading } = useSelector((state) => state.box);

  const { openAlert } = useContext(AlertContext);

  const handleCreateNewStorage = () => {
    const realColumn = alphabets[column - 1];
    const body = {
      name,
      column: realColumn,
      row: rows,
      rack: 1,
    };
    dispatch(createNewStorages(body));
  };

  useEffect(() => {
    if (newStorages) {
      openAlert({
        message: 'New storages created',
        severity: 'success',
      });
      setName('');
      handleClose();
    }
  }, [newStorages]);

  return (
    <Elements.ModalBase
      handleClose={handleClose}
      handleAgree={handleCreateNewStorage}
      open={!!open}
      maxWidth="lg"
      fullWidth
      smallBtn
      confirmText="Add New"
      disabled={!name || isLoading || !rows || !column}
      isLoading={isLoading}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box fontSize={18} fontWeight="700">Add New Aisle</Box>
        <IconButton sx={{ py: 0 }} onClick={handleClose}>
          <CloseRounded />
        </IconButton>
      </Box>

      <Grid container spacing={3} sx={{ mt: 0.5 }}>
        <Grid item md={5}>
          <Box>
            <div className="s-14 weight-600 mt-2">
              Aisle Name
              <span className="primary-green">*</span>
            </div>
            <TextField value={name} onChange={({ target }) => setName(target.value)} size="small" fullWidth sx={{ mt: 0.5 }} />
          </Box>
          <Box mt={2}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <div className="s-14 weight-600 mt-2">
                Total Rows
                <span className="primary-green">*</span>
              </div>
              <Box fontWeight="600" color="#586479" fontStyle="italic" fontSize={12}>Max 12 rows</Box>
            </Box>
            <TextField
              fullWidth
              size="small"
              value={rows}
              onChange={({ target }) => {
                const realVal = Number(onlyNumbers(target.value));
                if (realVal < 0 || realVal > 12) {
                  setRows(rows);
                } else {
                  setRows(realVal);
                }
              }}
              InputProps={{
                startAdornment: (
                  <IconButton sx={{ p: 0, color: '#404852' }} onClick={() => setRows(Number(rows > 1 ? rows - 1 : 1))}>
                    <RemoveCircleOutlineRounded />
                  </IconButton>
                ),
                endAdornment: (
                  <IconButton sx={{ p: 0, color: '#404852' }} onClick={() => setRows(Number(rows < 12 ? rows + 1 : 12))}>
                    <AddCircleOutlineRounded />
                  </IconButton>
                ),
              }}
              inputProps={{ min: 0, style: { textAlign: 'center' } }}
              sx={{ mt: 0.5 }}
            />
          </Box>
          <Box mt={2}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <div className="s-14 weight-600 mt-2">
                Total Columns
                <span className="primary-green">*</span>
              </div>
              <Box fontWeight="600" color="#586479" fontStyle="italic" fontSize={12}>Max 12 columns</Box>
            </Box>
            <TextField
              fullWidth
              size="small"
              value={column}
              onChange={({ target }) => {
                const realVal = Number(onlyNumbers(target.value));
                if (realVal < 0 || realVal > 12) {
                  setColumn(column);
                } else {
                  setColumn(realVal);
                }
              }}
              InputProps={{
                startAdornment: (
                  <IconButton sx={{ p: 0, color: '#404852' }} onClick={() => setColumn(Number(column > 1 ? column - 1 : 1))}>
                    <RemoveCircleOutlineRounded />
                  </IconButton>
                ),
                endAdornment: (
                  <IconButton sx={{ p: 0, color: '#404852' }} onClick={() => setColumn(Number(column < 12 ? column + 1 : 12))}>
                    <AddCircleOutlineRounded />
                  </IconButton>
                ),
              }}
              inputProps={{ min: 0, style: { textAlign: 'center' } }}
              sx={{ mt: 0.5 }}
            />
          </Box>
        </Grid>
        <Grid item md={7}>
          <Box
            border="1px solid #E5E5E5"
            borderRadius="10px"
            py={1}
            px={2}
            boxSizing="border-box"
          >
            <Box fontWeight="600" color="#586479" fontStyle="italic" fontSize={12}>Preview</Box>
            <Box display="flex" flexDirection="column" alignItems="center" className={classes.preview}>
              <table cellSpacing={6}>
                <thead>
                  <tr>
                    <td aria-label="empty-td" />
                    {new Array(column).fill(null).map((col, id) => (
                      <td className="s-10 center weight-700 mute" key={id}>{alphabets[id]}</td>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {new Array(rows).fill(null).map((ev, i) => (
                    <tr key={i}>
                      <td className="s-10 weight-700 mute">{i + 1}</td>
                      {new Array(column).fill(null).map((col, id) => (
                        <td key={id} aria-label={id}>
                          <div className="storage empty" />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Divider sx={{ mt: 2 }} />
    </Elements.ModalBase>
  );
}
